
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
XHeader,
Group,
Cell,
XButton,
CellFormPreview,
PopupRadio,
XInput
},
data() {
return {
withDrawList: [],
balance: '获取中',
wdAmount: '',

isDisabled: false,
showLoading: false,
showInput: false,
cardOption: '',
cardList: [],
}
},
created: function () {
document.title = '提现列表'
this.$http.get(this.tianYiWebUrl + '/wechat/withdraw/getList').then(r => {
let res = r.data
console.log(res)
this.withDrawList = res.data.list.data
this.balance = res.data.balance
});
},
methods: {
getCardList() {
this.$vux.loading.show('数据加载中')
const url = this.tianYiWebUrl + '/wechat/bankcard/getCardList'
this.$http.get(url).then(r => {
this.$vux.loading.hide()
if (r.data.code === 200) {
this.cardList = r.data.data
if (this.cardList.length === 0) {
let _self = this
this.$vux.confirm.show({
text: '未填写任何卡号',
content: '是否立即前往增加',
onConfirm() {
_self.$router.push('/uc/bankcard')
}
})
}
} else {
this.$vux.toast.show({
text: '卡号数据获取失败',
type: 'cancel'
})
}
})
},
start() {
if (this.showInput === false) {
this.showInput = true
} else {
if (this.cardOption === '') {
this.$vux.toast.show({text: '请选择卡', type: 'cancel'})
return;
}
if (this.wdAmount < 10 || this.wdAmount > this.balance) {
this.$vux.toast.show({text: '提现金额必须为 10 - ' + this.balance + ' 元', type: 'cancel'})
return;
}



this.isDisabled = true;
this.showLoading = true;
const url = this.tianYiWebUrl + '/wechat/withdraw/submit'
this.$http.post(url, {amount: this.wdAmount, cardId: this.cardOption}).then(r => {
let title = '';
let content = '';
if (r.data.code === 200) {
title = '操作成功';
this.balance = r.data.data;
this.wdAmount = 0;
} else {
title = '操作失败';
}

this.$vux.confirm.show({
text: title,
content: r.data.message,
})

this.isDisabled = false;
this.showLoading = false;
})
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/WithDraw.vue